import { Grid } from '@material-ui/core';
import { Select, Button, Tooltip, Icon } from 'antd';
import TextEvents from 'app/components/TextEvents';
import { ListadoKeyUserReducer } from 'app/reducers/ListadoKeyUserReducer';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styles, useStyles } from '../ListadoKeyUserScreenStyles';
import * as ListadoKeyUserActions from "app/actions/ListadoKeyUserActions";
import { employeeById } from 'app/reducers';

const FilterScreen = (props) => {
    const classes = useStyles();
    const [names, setNames] = useState([]);
    const [collapse, setCollapse] = useState(true);
    const [keyuser, setKeyuser] = useState([]);
    const dispatch = useDispatch();
    const { siteId } = useSelector(state => state.Auth)
    const employeeData = useSelector(employeeById);

    const {
        filter,
        isLoadingFilters,
    } = useSelector(state => state.ListadoKeyUserReducer);

    const data = {
        SystemName: names,
        KuName: keyuser
    }


    const onSelectNames = (names) => {
        setNames(names);
    }

    const onSelectKeyUser = (keyuser) => {
        setKeyuser(keyuser);
    }

    // const onSelectFunctional = (functional) => {
    //     props.setFiltroFuncional(functional);
    // }



    const search = () => {
        dispatch(ListadoKeyUserActions.getKeyUsers(data))
    }

    const exportXls = () => {
        dispatch(ListadoKeyUserActions.exportXls(data))
    }

    const optionsNames = filter.listSystems.map((item) =>
        <Select.Option key={item} value={item}>{item}</Select.Option>
    );

    const optionsKeyUsers = filter.listNames.map((item) =>
        <Select.Option key={item} value={item}>{item}</Select.Option>
    );



    return (
        <div>
            <div hidden={collapse}>
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={6} >
                        <TextEvents
                            text='Sistemas:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingFilters}
                            placeholder="[Selecionar Nombre]"
                            showSearch
                            value={names}
                            onChange={onSelectNames}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {optionsNames}
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <TextEvents
                            text='KeyUser:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingFilters}
                            placeholder="[Selecionar KeyUser]"
                            showSearch
                            value={keyuser}
                            onChange={onSelectKeyUser}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {optionsKeyUsers}
                        </Select>
                    </Grid>
                </Grid>
            </div>
            {/**Botones */}
            <div className={classes.container} style={styles.baseVerticalMargin}>
                {
                    collapse ?
                        <Tooltip title={"Mostrar filtro"}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="link"
                                onClick={() => setCollapse(false)}
                            >
                                <Icon type="down" />
                            </Button>
                        </Tooltip> :
                        <Tooltip title={"Ocultar filtro"}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="link"
                                onClick={() => setCollapse(true)}
                            >
                                <Icon type="up" />
                            </Button>
                        </Tooltip>
                }

                <Button
                    className={classes.button}
                    variant="contained"
                    type="primary"
                    onClick={() => search()}
                >
                    Buscar
                </Button>
                <Button
                    className={classes.button}
                    variant="contained"
                    type="primary"
                    onClick={() => exportXls()}
                >
                    Exportar
                </Button>
            </div>
        </div>
    );
}

export default FilterScreen;
